import moment from 'moment';
import {combineReducers} from 'redux';
import _ from 'lodash';
import {
    CurrentUserActions,
} from '../actions/ActionTypes';
import {windows} from './windowsReducer';
import {simbix} from '../simbix/simbixReducer'
import {pie} from './pieReducer'
import {docs} from './docsReducer'
import {vadms, vasset, vcatalogs} from '../redux/AdmsReducer'
import {vowl, vselected, subjects} from '../redux/OwlReducer'
import {vset} from '../redux/SettingsReducer'
import {lwiki} from '../redux/WikiReducer'
import {ldml} from '../redux/DMLReducer'
import {emd} from '../redux/EMDReducer'
import {xsd} from '../redux/XSDReducer'
import {vviews} from '../redux/ModelViewsReducer'
import {iep} from '../redux/IEPReducer'
import {selected} from '../views/models/redux/selected_reducer'
import {linker} from '../redux/LinkerReducer'
import {webprotege} from '../redux/WebProtegeReducer'
import {xwiki} from '../redux/XWikiReducer'
import {schemes, scheme} from '../redux/SkosReducer'
import {vocabs, vindivid} from '../redux/VocabsReducer'

const initialApplication = {
    beginDate: moment().format('DD.MM.YYYY'),
    isRepeated: false,
    isConditional: false,
    note: '',
    weight: '',
    volume: '',
};


function currentUser(state = {}, action) {
    switch (action.type) {
        case CurrentUserActions.LOAD_OK:
            return {
                ...state,
                ...action.currentUser,
            };
        case CurrentUserActions.LOAD_AUTH_OK:
            return {
                ...state,
                ...action.value,
            };
        default:
            return state;
    }
}

export default combineReducers({
    currentUser,
    windows,
    simbix,
    emd,
    pie,
    docs,
    vadms,
    vasset,
    vowl,
    vset,
    vselected,
    lwiki,
    ldml,
    xsd,
    vviews,
    iep,
    selected,
    linker,
    webprotege,
    xwiki,
    schemes, 
    scheme,
    vocabs,
    vindivid,
    subjects,
    vcatalogs
});
